import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Whitelabels } from '../../constants';
import AuthPageWrap from './AuthPageWrap';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function AuthBoxWrap({ children }: Props) {
  const whitelabel = Whitelabels.getWhitelabel();
  return (
    <AuthPageWrap>
      <html.img style={styles.logo} src={whitelabel.logo} />
      <html.div style={styles.box}>{children}</html.div>
    </AuthPageWrap>
  );
}

const styles = css.create({
  logo: {
    width: 130,
    marginBottom: 60,
  },
  box: {
    maxWidth: 364,
    width: '100%',
    backgroundColor: color.neutral0,
    paddingBlock: 40,
    paddingInline: 40,
    borderRadius: 8,
    '@media (max-width: 400px)': {
      paddingBlock: 30,
      paddingInline: 15,
      borderRadius: 0,
    },
  },
});
